import AV from 'leancloud-storage'
export const Quiz = AV.Object.extend('Quiz')
export const QuizQuestion = AV.Object.extend('QuizQuestion')
export const QuizResult = AV.Object.extend('QuizResult')
export const QuizBaseQuestion = AV.Object.extend('QuizBaseQuestion')

// 获取 quiz
Quiz.getById = function (id) {
    return AV.Cloud.rpc('getQuizById', { quizId: id })
}

// 获取全部测验
Quiz.getAll = function (page = 1, perPage = 15, host) {
    return AV.Cloud.rpc('getQuizsForH5', { page, perPage, host })
}

// 获取全部测验（用于测试）
Quiz.getAllForTest = function (page = 1, perPage = 15) {
    return AV.Cloud.rpc('getQuizsForTest', { page, perPage })
}

// 获取全部问题
Quiz.getQuestions = function (quizId) {
    return AV.Cloud.rpc('getQuizQuestions2', { quizId })
}

// 获取全部答题结果
Quiz.getResults = function (quizId, page = 1, perPage = 15) {
    return AV.Cloud.rpc('getQuizResults', { quizId, page, perPage })
}

// 获取我的答题结果
Quiz.getMyResult = function (quizId) {
    let user = AV.User.current()
    if (!user) {
        throw new Error('Sign in first')
    }
    return AV.Cloud.rpc('getMyQuizResult', { quizId })
}

// 开始测验
Quiz.start = function (quizId) {
    return AV.Cloud.run('startQuiz', { quizId })
}

// 结束测验
Quiz.finish = function (quizId, quizResultId) {
    return AV.Cloud.run('finishQuiz', { quizId, quizResultId })
}

Quiz.getMyQuizQuestionResults = function (quizId, quizResultId) {
    return AV.Cloud.rpc('getMyQuizQuestionResults', { quizId, quizResultId })
}

// 回答问题
QuizBaseQuestion.prototype.answer = function (quizId, answer, quizResultId) {
    return AV.Cloud.run('answerQuizQuestion2', { quizId, questionId: this.id, answer, quizResultId })
}

// 跳过问题
QuizBaseQuestion.prototype.skip = function (quizId, quizResultId) {
    return AV.Cloud.run('skipQuizQuestion2', { questionId: this.id, quizId, quizResultId })
}

QuizResult.getById = function (quizResultId) {
    return AV.Cloud.rpc("getQuizResultById", { id: quizResultId })
}



// WEBPACK FOOTER //
// ./src/models/quiz.js